import mitt from 'mitt'

const eventBus = mitt()

export function installEventBus() {
    return {
        install: (app, options) => {
            app.config.globalProperties.$eventBus = eventBus
        }
    }
}

export function useEventBus() {
    return eventBus
}

export default eventBus
